<template>
  <div class="footer-box">
    <div class="footer">
      <div class="footer-left">
        <img src="@/assets/image/logo-black.webp" alt="" />
        <h3>Este sitio web es operado por FRS CARIBE SAS.</h3>
        <p>
          <span @click="openLoan">Acuerdo de préstamo</span>
          <span @click="openUser">Términos y Condiciones</span>
          <a href="https://t.me/FRSCOMPANIA">Telegram</a>
          <span @click="$router.push('contact')">Contactarnos</span>
        </p>
      </div>
      <div class="footer-right">
        <div class="footer-col">
          <div>
            <div class="footer-key">
              <img src="@/assets/image/icon-tel.webp" alt="" />
              <span>NÚMERO DE TELÉFONO:</span>
            </div>
            <div class="footer-val">3241000766</div>
          </div>
          <div>
            <div class="footer-key">
              <img src="@/assets/image/icon-mail.webp" alt="" />
              <span>CORREO ELECTRÓNICO:</span>
            </div>
            <div class="footer-val">service@frscompania.co</div>
          </div>
        </div>

        <div class="footer-col">
          <div>
            <div class="footer-key">
              <img src="@/assets/image/icon-tel1.webp" alt="" />
              <span>WHATSAPP:</span>
            </div>
            <div class="footer-val">573160984509</div>
          </div>
          <div>
            <div class="footer-key">
              <img src="@/assets/image/icon-time.webp" alt="" />
              <span>HORARIO LABORAL:</span>
            </div>
            <div class="footer-val">
              <span>L-v 8:00 a 17:00</span>
              <span style="margin-left: 12px"> S 8:00 a 12:00 </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Modal v-model="pactVisible" :footer-hide="true" width="1000" class-name="vertical-center-modal">
      <template slot="close">
        <img class="icon-close" src="@/assets/image/icon-close.webp" alt="" />
      </template>
      <div class="pact-box">
        <div class="pact-header">
          <div class="pact-title">
            {{ pactType == 'loan' ? 'Acuerdo de préstamo' : 'Términos y condiciones' }}
          </div>
        </div>
        <div class="pact">
          <LoanPact v-if="pactType == 'loan'"></LoanPact>
          <UserPact v-else></UserPact>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import LoanPact from './loanPact.vue'
import UserPact from './userPact.vue'
export default {
  components: {
    LoanPact,
    UserPact,
  },
  data () {
    return {
      pactVisible: false,
      pactType: '',
    }
  },
  methods: {
    openLoan () {
      this.pactType = 'loan'
      this.pactVisible = true
    },
    openUser () {
      this.pactType = 'user'
      this.pactVisible = true
    },
  },
}
</script>
<style lang="less" scoped>
.footer-box {
  width: 100%;
  height: 144px;
  background: #ffffff;
  margin-top: 32px;

  .footer {
    width: 1190px;
    height: 100%;
    margin: 0 auto;
    padding: 20px 0;
    display: flex;
    justify-content: space-between;

    .footer-left {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      img {
        width: 146px;
        margin-top: 11px;
        margin-left: 4px;
      }

      h3 {
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        color: #666666;
        margin-bottom: 5px;
      }

      p {
        display: flex;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;

        span {
          color: #666666;
          margin-right: 20px;
          cursor: pointer;
        }

        a {
          color: #666666;
          margin-right: 20px;
          cursor: pointer;
        }

        span:last-child {
          margin-right: 0;
        }
      }
    }

    .footer-right {
      display: flex;

      .footer-col {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: 25px;
      }

      .footer-key {
        height: 30px;
        display: flex;
        align-items: center;

        img {
          width: 12px;
          height: 12px;
        }

        span {
          font-weight: 400;
          font-size: 12px;
          color: #666666;
          margin-left: 10px;
        }
      }

      .footer-val {
        font-weight: 500;
        font-size: 12px;
        color: #333333;
      }
    }
  }
}

.pact-box {
  width: 100%;
  height: 650px;
  background: linear-gradient(180deg, #fef1b6 0%, #ffffff 27%);
  border-radius: 16px;

  .pact-header {
    width: 100%;
    height: 106px;
    padding-top: 40px;
    display: flex;
    justify-content: center;
    border-bottom: 1px solid #cccccc;

    .pact-title {
      // width: 505px;
      // height: 46px;
      padding-left: 16px;
      font-weight: 600;
      font-size: 26px;
      color: #000000;
      line-height: 46px;
      position: relative;
      margin-bottom: 20px;
    }

    .pact-title::before {
      content: '';
      display: block;
      width: 6px;
      height: 30px;
      background: #ffe955;
      position: absolute;
      left: 0;
      top: 8px;
    }
  }

  .pact {
    width: 880px;
    height: 500px;
    margin: 20px auto;
    padding: 20px;
    overflow-x: hidden;
    overflow-y: scroll;
    background: #f4f4f4;
    border-radius: 10px;
  }
}

.icon-close {
  width: 40px;
}

/deep/ .ivu-modal-body {
  padding: 0;
}

/deep/ .ivu-modal-content {
  border-radius: 16px;
}

/deep/ .vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}
</style>
